import { useMemo } from 'react';
import { useChatApi } from '../Services/ChatApiProvider';
import { messageClassNames, sanitizeMessageHtml } from '../Services/messageHtml';
import { messageRehypePlugins } from '../Services/messageMarkdown';

/**
 * How this widget's channel lets message HTML through: messages may carry only the class
 * names the channel's message styles define. `rehypePlugins` is for Markdown messages,
 * `sanitize` for raw HTML (HTML messages and fragment controls).
 */
export function useMessageHtml() {
  const { channelSettings } = useChatApi();
  const css = channelSettings?.messageCss;

  return useMemo(() => {
    const classNames = messageClassNames(css);
    return {
      rehypePlugins: messageRehypePlugins(classNames),
      sanitize: (html) => sanitizeMessageHtml(html, classNames),
    };
  }, [css]);
}
